module.exports = __webpack_public_path__ + "img/Case_10.88145022.jpg";